import type { ListFilter } from '../../domain/tx';

/** Reference implementation of ListFilter semantics, shared by both adapters. */
export function applyFilter<T>(rows: T[], f?: ListFilter<T>): T[] {
  if (!f) return rows;
  let out = rows;
  if (f.where) {
    const entries = Object.entries(f.where) as Array<[keyof T, unknown]>;
    out = out.filter((r) => entries.every(([k, v]) => r[k] === v));
  }
  if (f.range) {
    const { field, gte, lt } = f.range;
    out = out.filter((r) => {
      const v = r[field] as unknown as string | number;
      return (gte === undefined || v >= gte) && (lt === undefined || v < lt);
    });
  }
  if (f.filter) out = out.filter(f.filter);
  return f.limit !== undefined ? out.slice(0, f.limit) : out;
}
